<template>
    <div
        :data-component-name="$options.name"
        class="c-tag-list"
    >
        <span v-bind:key="index" v-for="(tag, index) in tags">
            <q-chip removable @remove="tags.splice(index, 1)" :color="color" text-color="white" size="sm">
                {{ tag.name }}
            </q-chip>
        </span>
    </div>
</template>

<script>

    export default {
        name: 'CoursesList',
        props: [
            "tags",
            "color"
        ],
        data(){
            return {

            }
        },
        computed: {
        }
    }
</script>

<style lang="scss">

    .c-tag-list .q-chip__icon {
        line-height: 0.8;
    }

</style>